import React, { useCallback, useContext, useEffect, useState } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ProductImage from '@prisjakt/ui-product-image';
import ToggleSearchButton from '../../buttons/toggle-search-button';
import { includes } from '../../../helpers';
import { Product } from '../../../types';

import * as S from './styles';

type OwnProps = {
  columnWidth: number;
  positionIndexes: number[];
  products: Product[];
  totalVisibleItems: number;
};

const CompareCarouselItems = ({
  columnWidth,
  positionIndexes,
  products,
  totalVisibleItems,
}: OwnProps) => {
  const { linkTo } = useContext(AppContext);

  const [activeIndexes, setActiveIndexes] = useState<number[]>(
    [...Array(totalVisibleItems)].map((val, index) => index)
  );
  const [imagesTranslateX, setImagesTranslateX] = useState(0);

  const setDirection = useCallback(
    (isForward: boolean) => {
      // Prevents position to change past products.length
      if (isForward && includes(activeIndexes, products.length - 1)) return;
      if (!isForward && includes(activeIndexes, 0)) return;
      const newActiveIndexes = activeIndexes.map(i =>
        isForward ? i + 1 : i - 1
      );

      setImagesTranslateX(
        isForward
          ? imagesTranslateX - columnWidth
          : imagesTranslateX + columnWidth
      );
      setActiveIndexes(newActiveIndexes);
    },
    [activeIndexes, columnWidth, imagesTranslateX, products.length]
  );

  // Sets direction when position indexes changes
  useEffect(() => {
    if (
      positionIndexes &&
      JSON.stringify(activeIndexes) !== JSON.stringify(positionIndexes)
    ) {
      const directionForward = positionIndexes[0] > activeIndexes[0];
      const jumps = directionForward
        ? positionIndexes[0] - activeIndexes[0]
        : activeIndexes[0] - positionIndexes[0];

      [...Array(jumps)].forEach(() => setDirection(directionForward));
    }
  }, [activeIndexes, positionIndexes, setDirection]);

  const renderPlaceholderProduct = () => {
    return (
      <S.Product width={columnWidth}>
        <ToggleSearchButton />
      </S.Product>
    );
  };

  return (
    <S.Products>
      <S.InnerWrapper translateX={imagesTranslateX}>
        {products.map(product => {
          return (
            <S.Product width={columnWidth} key={product.id}>
              <S.ProductLink to={linkTo('product', product)}>
                {product.media && product.media.first ? (
                  <S.ProductImage>
                    <ProductImage
                      src={product.media.first}
                      name={product.name}
                    />
                  </S.ProductImage>
                ) : null}
                <S.ProductName>{product.name}</S.ProductName>
              </S.ProductLink>
            </S.Product>
          );
        })}
        {products.length === 1 && renderPlaceholderProduct()}
      </S.InnerWrapper>
    </S.Products>
  );
};

export default CompareCarouselItems;
